import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { PlusIcon } from '../icons'

export interface ISubmitDropoffButtonProps {
    onClick: () => void
}

const SubmitDropoffButton: React.FC<ISubmitDropoffButtonProps> = ({
    onClick
}) => {
    const intl = useIntl()
    return (
        <SubmitButton onClick={onClick}>
            <PlusIcon/>
            <ButtonLabel>{intl.formatMessage({id: 'SelectorPanel.ActionButton.Submit'})}</ButtonLabel>
        </SubmitButton>
    )
}

const SubmitButton = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
    align-items: center;
    padding: 12px;
    color: ${({ theme }) => theme.color.secondary};
    background-color: ${({ theme }) => theme.color.primary};
    border-radius: 4px;
    line-height: 1.8em;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.25);
`

const ButtonLabel = styled.div`
    flex-grow: 1;
    text-align: left;
    font-style: normal;
    margin-left: 8px;
    font-weight: ${({ theme }) => theme.weight.normal};
    font-size: ${({ theme }) => theme.size.small};
    color: ${({ theme }) => theme.color.secondary};
`

export default SubmitDropoffButton
